<template>
  <div class="container">
    <van-nav-bar
      title="规格管理"
      left-text="返回"
      right-text
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      class="navbar"
    >
      <van-icon name="plus" size=".3rem" slot="right" />
    </van-nav-bar>
    <van-search placeholder="请输入搜索关键词" class="search fixed" @search="onSearch" v-model="keyword" />
    <van-row class="table-header fixed">
      <van-col span="3">
        <van-checkbox @click="onSelectedAll" v-model="checkedAll" />
      </van-col>
      <van-col span="7">名称</van-col>
      <van-col span="5">价格</van-col>
      <van-col span="5">显示</van-col>
      <van-col span="5">操作</van-col>
    </van-row>
    <div class="content-scroll-list-wrap table-header-navbar footernavbar" ref="scrollWrapper">
      <cube-scroll
        ref="contentScroll"
        :data="list"
        :options="options"
        @pulling-up="onPullingUp"
        @pulling-down="onPullingDown"
      >
        <div class="nodata" v-if="!list.length">没有到任何数据!</div>
        <van-checkbox-group v-model="selected">
          <van-row class="table-list-data" v-for="(item,index) in list">
            <van-col span="3">
              <van-checkbox :key="item.id" :name="item.id" />
            </van-col>
            <van-col span="7">{{item.title}}</van-col>
            <van-col span="5">{{item.price}}</van-col>
            <van-col span="5">
              <van-icon name="eye-o" v-if="item.status" size="20px" @click="isshow(item)" />
              <van-icon name="closed-eye" v-else size="20px" @click="isshow(item)" />
            </van-col>
            <van-col span="5">
              <van-icon name="edit" size="20px" @click="edit(item)" />
            </van-col>
          </van-row>
        </van-checkbox-group>
      </cube-scroll>
    </div>
    <div class="footer-navbar">
      <van-button type="danger" class="op-delete" @click="onDelete">删除</van-button>
    </div>
  </div>
</template>

<script>
import { SpecModel } from "@models/admin/spec";
import { ERR_OK } from "@/common";
const specModel = new SpecModel();

export default {
  data() {
    return {
      list: [],
      options: {
        pullDownRefresh: {
          threshold: 60,
          stopTime: 1000,
          txt: "更新成功"
        },
        pullUpLoad: {
          txt: {
            noMore: "没有了"
          }
        }
      },
      checkedAll: false,
      selected: [],
      totalpage: 1,
      page: 1,
      keyword: ""
    };
  },
  methods: {
    onSelectedAll() {
      this.checkAll = !this.checkAll;
      this.selected = this.$checkedAll(this.list, this.checkAll);
    },
    onClickLeft() {
      this.$redirect("/admin/index");
    },
    onClickRight() {
      this.$delCache("spec_data");
      this.$redirect("/admin/spec/post");
    },
    onPullingUp() {
      if (this.page < this.totalpage) {
        setTimeout(() => {
          this.page++;
          this.get_list();
        }, 1000);
      } else {
        this.$refs.contentScroll.forceUpdate();
      }
    },
    onPullingDown() {
      let params = {};
      setTimeout(() => {
        this.list = [];
        this.page = 1
        if (this.keyword) {
          params = {
            keyword: this.keyword
          };
        }
        this.get_list(params);
      }, 1000);
    },
    onDelete() {
      if (this.selected.length == 0) {
        this.$toast("至少勾选一个选项");
        return false;
      }
      this.$dialog
        .confirm({
          message: "确定要删除这些规格?",
          cancelButtonText: "取消",
          confirmButtonText: "确定"
        })
        .then(() => {
          specModel
            .delete({
              ids: this.selected
            })
            .then(res => {
              if (res.code == ERR_OK) {
                this.$toast("删除成功!");
                setTimeout(() => {
                  this.list = [];
                  this.get_list();
                }, 1000);
              } else {
                this.$toast(res.msg);
              }
            });
          // this.$redirect("/admin/merch");
        });
    },
    onSearch() {
      this.list = [];
      this.page = 1;
      this.get_list({
        keyword: this.keyword
      });
    },
    get_list(params = {}) {
      let obj = {
        user_token: localStorage.user_token,
        page: this.page
      };
      Object.assign(obj, params);
      specModel.get_list(obj).then(res => {
        if (ERR_OK == res.code) {
          this.totalpage = res.data.last_page;
          this.list = this.list.concat(res.data.data);
        }
      });
    },
    edit(data) {
      this.$setCache("spec_data", data);
      this.$redirect("/admin/spec/post", { id: data.id });
    },
    isshow(data) {
      this.list.forEach((item, index) => {
        if (data.id == item.id) this.list[index].status = !data.status;
      });

      specModel.isshow({
        id: data.id,
        status: data.status
      });
    },
    onEvent() {
      let name = this.$getCache("data_name");
      let event = this.$getCache("event");
      if (event == "update") {
        let data = this.$getCache(name);
        this.list.forEach((item, index) => {
          if (item.id == data.id) {
            this.list.splice(index, 1, data);
          }
        });
      } else if (event == "add") {
        this.list = [];
        this.get_list();
      }
      this.$setCache("data_name", "");
      this.$setCache("event", "");
    }
  },
  created() {
    this.get_list();
  },
  activated() {
    this.onEvent();
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.navbar {
  color: #fff;
  background: #2196f3;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.content-scroll-list-wrap img {
  max-width: 100%;
}
>>>.table-header {
  top: 2rem;
}

>>>.content-scroll-list-wrap.footernavbar {
  height: calc(100% - 0.92rem - 0.8rem - 0.92rem - 1.1rem);
}

>>> .content-scroll-list-wrap.table-header-navbar {
  top: 2.8rem;
}

</style>
